import { render } from "./ads1.Webhumsafar.vue?vue&type=template&id=65dad12a"
import script from "./ads1.Webhumsafar.vue?vue&type=script&lang=js"
export * from "./ads1.Webhumsafar.vue?vue&type=script&lang=js"

import "./ads1.Webhumsafar.vue?vue&type=style&index=0&id=65dad12a&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__